export default __webpack_public_path__ + "static/media/GPA_BeattheBeak_Banner.5a6701cd.jpg";